import { DiagnosisCode } from 'src/contracts/diagnosisCode';
import { isEmpty } from 'src/common/arrayUtil';

export function addDiagnosisCodes(current: DiagnosisCode[] | undefined, newCodes: DiagnosisCode[] | undefined): void {
    if (!current || !newCodes || isEmpty(newCodes)) {
        return;
    }

    // clean up POAs
    newCodes.forEach(code => code.present_on_admission = code.present_on_admission?.trim());

    // Remove duplicates
    current.push(...newCodes.filter(code => !containsCode(current, code)));
}

function containsCode(current: DiagnosisCode[], code: DiagnosisCode): boolean {
    if (isEmpty(current) || !code || !code.code) {
        return false;
    }

    // Do we need to check any other code properties?
    return current.findIndex(c => c.code === code.code) >= 0;
}
